/**
 * The catalogue's tiny markup (docs/Localization.md) rendered as React: `**strong**`,
 * `*emphasis*`, `[[term]]` (a styled term), `[Key]` (a keycap). Translators move the marks with
 * the words, so no sentence has to be split around a tag.
 */
import { Fragment, type ReactNode } from 'react';

const TOKEN = /(\[\[[^\]]+\]\]|\[[^\]]+\]|\*\*[^*]+\*\*|\*[^*]+\*)/g;

export function richText(text: string, cls: { key?: string; term?: string } = {}): ReactNode[] {
  const out: ReactNode[] = [];
  let at = 0;
  for (const part of text.split(TOKEN)) {
    const key = at;
    at += part.length;
    if (!part) continue;
    if (part.startsWith('[[') && part.endsWith(']]'))
      out.push(
        <span key={key} className={cls.term}>
          {part.slice(2, -2)}
        </span>,
      );
    else if (part.startsWith('[') && part.endsWith(']') && part.length > 2)
      out.push(
        <kbd key={key} className={cls.key}>
          {part.slice(1, -1)}
        </kbd>,
      );
    else if (part.startsWith('**') && part.endsWith('**') && part.length > 4)
      out.push(<strong key={key}>{part.slice(2, -2)}</strong>);
    else if (part.startsWith('*') && part.endsWith('*') && part.length > 2)
      out.push(<em key={key}>{part.slice(1, -1)}</em>);
    else out.push(<Fragment key={key}>{part}</Fragment>);
  }
  return out;
}
